import React from 'react';

import {SidepanelChange, SidepanelInternalState} from './useFlowchartSidepanelManager';
import {SidepanelRegisterTabState} from './useFlowchartSidepanelUnsavedChanges';

export interface FlowchartSidepanelManagerContextValue {
  registerTab: (params: SidepanelRegisterTabState) => void;
  unregisterTab: (tab: string) => void;
  setIsTabDirty: (tab: string, isDirty: boolean) => void;
  canChangeSidepanel: (sidepanelChange: SidepanelChange) => Promise<boolean>;
  canChangeTab: (newTab: string, activeTab: string) => Promise<boolean>;
  forceClose: () => void;
  getEffectiveState: () => SidepanelInternalState;
}

export const FlowchartSidepanelManagerContext = React.createContext<FlowchartSidepanelManagerContextValue>({
  registerTab: () => {},
  unregisterTab: () => {},
  setIsTabDirty: () => {},
  canChangeSidepanel: () => Promise.resolve(true),
  canChangeTab: () => Promise.resolve(true),
  forceClose: () => {},
  getEffectiveState: () => ({node: null, fieldId: null, openSidepanelType: null}),
});
